import { useSentinelPastViewportEdge } from "@wags/tanstack-start/browser";
import { useUnsafeLayoutEffect } from "@wags/tanstack-start/react";
import { useState } from "react";
import {
    type PillHoldReason,
    createPillHold,
} from "@/features/kits-conversations";
import { useScrollPlaced } from "./use-scroll-placed";

const PILL_CLEARANCE_PX = 114;

export function KitsPillHold({ actionRow }: { actionRow: HTMLElement | null }) {
    const [sentinel, setSentinel] = useState<HTMLSpanElement | null>(null);
    const scrollPlaced = useScrollPlaced();
    const factsSeen = useSentinelPastViewportEdge(sentinel, "bottom", {
        enabled: scrollPlaced,
        offsetPx: PILL_CLEARANCE_PX,
    });
    const rowEntered = useSentinelPastViewportEdge(actionRow, "bottom", {
        enabled: scrollPlaced,
    });
    const rowCleared = useSentinelPastViewportEdge(actionRow, "bottom", {
        enabled: scrollPlaced,
        offsetPx: PILL_CLEARANCE_PX,
        sentinelEdge: "bottom",
    });
    const [read, setRead] = useState(false);
    (() => {
        if (factsSeen && !read) setRead(true);
    })();
    const reason = ((): PillHoldReason | null => {
        if (rowEntered && !rowCleared) return "covers-action-row";
        return read ? null : "unread";
    })();
    const [setPillHold] = useState(createPillHold);

    useUnsafeLayoutEffect(() => {
        if (reason === null) return;
        setPillHold(reason);
        return () => setPillHold(null);
    }, [reason]);

    return <span ref={setSentinel} aria-hidden="true" className="block" />;
}
